import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const footerCategories = categories.slice(0, 7);
const footerArticles = [
  { name: "Mulebuy Spreadsheet Guide", url: "/mulebuy-spreadsheet-guide-2026", external: false },
  { name: "Best Deals 2026", url: "/mulebuy-spreadsheet-best-deals-2026", external: false },
  { name: "Spreadsheet vs Traditional", url: "/mulebuy-spreadsheet-vs-traditional-shopping", external: false },
  { name: "Category Guide", url: "/mulebuy-spreadsheet-category-guide", external: false },
  { name: "Tips & Tricks", url: "/mulebuy-spreadsheet-tips-tricks-2026", external: false },
  { name: "European Shoppers", url: "/mulebuy-spreadsheet-european-shoppers", external: false },
  { name: "Price Tracking", url: "/mulebuy-spreadsheet-price-tracking", external: false },
  { name: "Beginner's Guide", url: "/mulebuy-spreadsheet-beginners-guide", external: false },
  { name: "Safety & Security", url: "/mulebuy-spreadsheet-safety-security", external: false },
  { name: "2026 Updates", url: "/mulebuy-spreadsheet-2026-updates", external: false },
];
const footerAbout = [
  { name: "About This Site", url: "/", external: false },
  { name: "Privacy Policy", url: "/", external: false },
  { name: "Terms of Use", url: "/", external: false },
];
const footerLegal = [
  { name: "Disclaimer", url: "/", external: false },
  { name: "Cookie Policy", url: "/", external: false },
  { name: "DMCA", url: "/", external: false },
];

export default function Footer() {
  return (
    <footer className="relative bg-background-950 text-background-50 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[500px]">
          <svg viewBox="0 0 800 500" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 200 Q200 50 400 200 T700 200" stroke="white" strokeWidth="1" fill="none" opacity="0.5"/>
            <path d="M50 280 Q250 150 400 280 T750 280" stroke="white" strokeWidth="1" fill="none" opacity="0.3"/>
            <path d="M150 360 Q300 250 500 360 T650 360" stroke="white" strokeWidth="1" fill="none" opacity="0.4"/>
            <circle cx="400" cy="200" r="3" fill="white" opacity="0.3"/>
            <circle cx="200" cy="150" r="2" fill="white" opacity="0.3"/>
            <circle cx="600" cy="180" r="2" fill="white" opacity="0.3"/>
            <circle cx="350" cy="300" r="2" fill="white" opacity="0.2"/>
            <circle cx="500" cy="350" r="2" fill="white" opacity="0.2"/>
          </svg>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block group">
              <span className="font-heading text-2xl font-bold tracking-tight text-background-50">
                Mulebuy<span className="text-accent-500">Spreadsheets</span>
              </span>
            </Link>
            <p className="mt-4 text-background-300 text-sm leading-relaxed max-w-sm">
              Your trusted informational hub for Mulebuy spreadsheet insights, comparisons, and shopping guides. Helping shoppers make smarter decisions since 2026.
            </p>

            <form
              className="mt-6 flex items-center gap-0"
              data-readdy-form
              onSubmit={(e) => {
                e.preventDefault();
                const form = e.target as HTMLFormElement;
                const formData = new FormData(form);
                const params = new URLSearchParams();
                formData.forEach((value, key) => {
                  params.append(key, value.toString());
                });
                fetch("https://readdy.ai/api/form/d8smp9jf81iibef4bpgg", {
                  method: "POST",
                  headers: { "Content-Type": "application/x-www-form-urlencoded" },
                  body: params.toString(),
                })
                  .then(() => {
                    const input = form.querySelector("input") as HTMLInputElement;
                    if (input) input.value = "";
                    alert("Thank you for subscribing!");
                  })
                  .catch(() => {
                    alert("Something went wrong. Please try again.");
                  });
              }}
            >
              <input
                type="email"
                name="email"
                placeholder="Your email for updates"
                className="px-4 py-2.5 bg-background-800 text-background-100 text-sm rounded-l-md outline-none w-56 placeholder:text-background-500"
                required
              />
              <button
                type="submit"
                className="w-10 h-10 flex items-center justify-center bg-accent-500 hover:bg-accent-400 text-background-50 rounded-r-md transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-notification-3-line"></i>
              </button>
            </form>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">Categories</h4>
            <ul className="space-y-2.5">
              {footerCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">Articles</h4>
            <ul className="space-y-2.5">
              {footerArticles.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.url}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">About</h4>
            <ul className="space-y-2.5">
              {footerAbout.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.url}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-150"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 MulebuySpreadsheets.hair. All rights reserved.
          </p>
          <div className="flex items-center gap-3">
            {["ri-twitter-x-line", "ri-instagram-line", "ri-facebook-line", "ri-pinterest-line"].map((icon) => (
              <a
                key={icon}
                href="#"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-md border border-background-700 text-background-400 hover:text-background-100 hover:border-background-500 transition-colors duration-200 cursor-pointer"
              >
                <i className={icon}></i>
              </a>
            ))}
          </div>
          <a
            href="/"
            className="text-xs text-background-500 hover:text-background-300 transition-colors duration-150"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}